import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 1.667c-4.592 0-8.334 3.741-8.334 8.333s3.742 8.333 8.333 8.333 8.334-3.741 8.334-8.333-3.742-8.333-8.334-8.333m3.333 8.958h-2.709v2.708a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625v-2.708H6.666A.63.63 0 0 1 6.041 10a.63.63 0 0 1 .625-.625h2.708V6.667A.63.63 0 0 1 10 6.042a.63.63 0 0 1 .625.625v2.708h2.709a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
    }, null, -1)
  ]))]))
}
export default { render: render }